(() => {
  const drawer = document.getElementById('CartDrawer');
  const openCart = () => { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('cart-open'); };
  const closeCart = () => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('cart-open'); };
  document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  const mobile = document.getElementById('MobileMenu');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  if (mobile && menuToggle) {
    menuToggle.addEventListener('click', () => {
      const open = mobile.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !mobile.classList.contains('is-open')) return;
      mobile.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      menuToggle.focus();
    });
  }

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const escapeHTML = value => String(value || '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  async function refreshCart(open = false) {
    const cart = await fetch(window.themeRoutes.cart + '.js').then(r => r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const items = document.getElementById('CartDrawerItems');
    const total = document.getElementById('CartDrawerTotal');
    if (total) total.textContent = money(cart.total_price);
    if (items) items.innerHTML = cart.items.length ? cart.items.map((item, i) => '<div class="drawer-item"><a href="'+escapeHTML(item.url)+'">'+(item.image?'<img src="'+escapeHTML(item.image)+'&width=180" alt="'+escapeHTML(item.product_title)+'">':'')+'</a><div><b>'+escapeHTML(item.product_title)+'</b><small>'+escapeHTML(item.variant_title)+'</small><span>'+money(item.final_line_price)+'</span><button type="button" data-remove-line="'+(i+1)+'">REMOVE</button></div></div>').join('') : '<p class="cart-empty">Your bag is waiting for pressure.</p>';
    if (open) openCart();
  }

  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector('[type=submit]');
    const message = form.querySelector('.product-form__message');
    button.disabled = true; message.textContent = 'ADDING...';
    try {
      const response = await fetch(window.themeRoutes.cartAdd + '.js', { method:'POST', body:new FormData(form), headers:{ Accept:'application/json' } });
      if (!response.ok) throw await response.json();
      await refreshCart(true); message.textContent = 'ADDED TO BAG.';
    } catch (error) { message.textContent = error.description || 'COULD NOT ADD THIS ITEM.'; }
    finally { button.disabled = false; }
  });

  document.addEventListener('click', async e => {
    const remove = e.target.closest('[data-remove-line]');
    if (remove) {
      remove.disabled = true;
      await fetch(window.themeRoutes.cartChange + '.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({line:Number(remove.dataset.removeLine),quantity:0}) });
      await refreshCart();
      return;
    }
    if (e.target.closest('[data-scroll-buy]')) document.querySelector('[data-product-form]')?.scrollIntoView({behavior:'smooth',block:'center'});
  });

  document.querySelectorAll('[data-sort-by]').forEach(select => select.addEventListener('change', () => {
    const url = new URL(location.href); url.searchParams.set('sort_by', select.value); location.href = url.toString();
  }));

  document.querySelectorAll('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const form = select.closest('form');
    const price = document.querySelector('[data-product-price]');
    const mobilePrice = document.querySelector('[data-mobile-price]');
    const compare = document.querySelector('[data-product-compare]');
    const button = form?.querySelector('[type=submit]');
    if (price) price.textContent = option.dataset.price;
    if (mobilePrice) mobilePrice.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare || option.dataset.compare === option.dataset.price; }
    if (button) {
      const available = option.dataset.available === 'true';
      const label = button.querySelector('[data-add-to-bag-label]');
      const icon = button.querySelector('[data-add-to-bag-icon]');
      button.disabled = !available;
      if (label) label.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
      else button.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
      if (icon) icon.hidden = !available;
    }
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({},'',url);
  }));
})();
